import React, { Component } from 'react';
import { connect } from 'react-redux';
import sessionsDateFormat, {
  sessionsTimeFormat
} from '../../../../helpers/formatSessionDate';
// COMMON COMPONENTS
import EditEmail from '../../../common/EditEmail';

class SendInvitation extends Component {
  state = {};

  render() {
    const {
      onClose,
      sessionDetails,
      name,
      handleAddEmailsClick,
      drawerKey
    } = this.props;

    const emails = [];

    sessionDetails.participantsEmails.forEach(email => {
      if (email.status === 'new' || email.status === 'sent') {
        emails.push({ email: email.email, status: email.status });
      }
    });

    return (
      <>
        <EditEmail
          participantsEmails={emails}
          // registration == invitation
          type="registration"
          trainer={name}
          sessionDate={sessionsDateFormat(sessionDetails.dates)}
          sessionType={sessionDetails.type}
          address={sessionDetails.address}
          trainers={sessionDetails.trainers}
          startTime={sessionsTimeFormat(sessionDetails.dates)}
          endTime={sessionDetails.endTime}
          shortId={sessionDetails.shortId}
          sessionId={sessionDetails._id}
          course={sessionDetails.course}
          backCallback={onClose}
          handleAddEmailsClick={handleAddEmailsClick}
          drawerKey={drawerKey}
          modules={sessionDetails.modules}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  sessionDetails: state.sessions.sessionDetails,
  loading: state.session.loading,
  name: state.auth.name
});

export default connect(mapStateToProps, {})(SendInvitation);
